module.exports = __webpack_public_path__ + "media/images/city/023-basilica-of-the-sacred-heart-feb2afa94e8f11848ddd06dd84bc42bd.svg";